import { IFilter, IProject } from 'pages/Projects/Projects.types';

export const findProjectById = (projects: IProject[], id: string) =>
  projects.find((p) => p.id === id);

export const filterProjects = (
  projects: IProject[],
  filter: IFilter
): IProject[] => {
  return filter.default !== true
    ? projects.filter(
        (p: IProject) =>
          p.dates.start.includes(filter.name) ||
          p.dates.end?.includes(filter.name)
      )
    : projects;
};
